import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=bd3aa84c"
import script from "./UploadTemplate.vue?vue&type=script&lang=js"
export * from "./UploadTemplate.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplate.vue?vue&type=style&index=0&id=bd3aa84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports